import { QuickOptionsProps } from './components/quick/QuickOptions';

import { createLazyComponent, LazyAction, LazyModule, LazyImport } from 'owa-bundling';
import { ComponentClass } from 'react';
export { ComponentClass };
import { lazyLoadAllowedOptions } from 'owa-allowed-options';
import { runAfterInitialRender } from 'owa-delayed-initialization';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "Options", webpackPrefetch: true */ './lazyIndex')
);

// Export delay loaded actions
export let lazyMountAndShowFullOptions = new LazyAction(lazyModule, m => m.mountAndShowFullOptions);
export let lazyHideFullOptions = new LazyImport(lazyModule, m => m.hideFullOptions);
export let lazyConfirmDirtyOptionsAndPerformAction = new LazyImport(
    lazyModule,
    m => m.confirmDirtyOptionsAndPerformAction
);

// Export delay loaded components
export var QuickOptions = createLazyComponent(lazyModule, m => m.QuickOptions);
export { QuickOptionsProps };

// Export synchronous utils
export { default as getOptionRouteState } from './utils/getOptionRouteState';

runAfterInitialRender(() => {
    lazyLoadAllowedOptions.importAndExecute();
});
